const initials = "LegacyExams/";

export const UPDATE_LEGACY_EXAM = `${initials}UPDATE_LEGACY_EXAM`;
export const UPDATE_FILTER = `${initials}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${initials}UPDATE_REDUCER`;